// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms[data-v-3e739bf0] {\n  text-align: center;\n  margin-top: 1.3rem;\n  font-size: 0.8rem;\n  width: 90%;\n  margin-left: auto;\n  margin-right: auto;\n  color: #6a6d82;\n}", ""]);
// Exports
module.exports = exports;
